import { authClient } from '@api/apiClient'
import { User } from '@features/auth/hooks/types'
import { useQuery } from '@tanstack/react-query'
import { TOKEN_KEY } from '../utils/constants'

export const useGetMe = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const response = await authClient.get<User>('/me', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
        },
      })
      return response.data
    },
    retry: false,
  })
}
